/**
 * ODE — gemeinsamer Warenkorb-Helfer fuer eigene Bloecke (Quiz, Drink-Rechner).
 * Nutzt denselben Weg wie das Theme (product-form.js, Batch-Add): CartLinesUpdateEvent
 * ausloesen, /cart/add.js mit mehreren Positionen, Warenkorb neu laden. Dadurch
 * aktualisieren sich Zaehler und Drawer, und der Drawer oeffnet sich wie gewohnt.
 *
 * window.odeKorb.add([{ id: 123, quantity: 2 }], quellElement) -> Promise<cart>
 */
import { CartLinesUpdateEvent } from '@shopify/events';

async function warenkorbLaden() {
  const c = document.querySelector('cart-items-component');
  if (c) {
    await customElements.whenDefined('cart-items-component');
    if (typeof c.fetchCartData === 'function') return c.fetchCartData();
  }
  const r = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.json`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  return r.json();
}

async function add(items, quelle) {
  items = items.filter((i) => i && i.id && i.quantity > 0);
  if (!items.length) return null;
  const sectionIds = [...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean);
  const menge = items.reduce((s, i) => s + i.quantity, 0);
  const d = CartLinesUpdateEvent.createPromise();
  (quelle || document.body).dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
      promise: d.promise,
    })
  );
  try {
    const res = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items.map((i) => ({ id: Number(i.id), quantity: i.quantity })), sections: sectionIds.join(',') }),
    }).then((r) => r.json());
    const cart = await warenkorbLaden();
    d.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'ode-korb', sourceId: 'ode-korb', itemCount: menge, sections: res.sections, didError: Boolean(res.status) },
    });
    if (res.status) throw new Error(res.description || res.message || 'Nicht verfügbar');
    return cart;
  } catch (e) {
    d.reject(e);
    throw e;
  }
}

window.odeKorb = { add };
document.dispatchEvent(new Event('ode-korb:bereit'));
